<template>
	<div class="chatting-container">
		<div class="chatting-header">
			<div class="chatting-header-wrap">
				<div class="chatting-h-basic">
					<img :src="chatUser.fans_wx_photo | connectHost" alt="">
					<div class="chatting-h-info">
						<p>{{chatUser.con_remark == '' ?chatUser.fans_wx_name:chatUser.con_remark}}</p>
						<p class="chatting-h-other" v-if="chatUser.type == 1">
							<span class="chatting-h-male" v-if="chatUser.sex == 1"></span>
							<span class="chatting-h-female" v-else-if="chatUser.sex == 2"></span>
							<span class="chatting-h-male" v-else></span>
							<span>{{chatUser.country}}&nbsp;·&nbsp;{{chatUser.province}}&nbsp;·&nbsp;{{chatUser.city}}</span>
						</p>
					</div>
					<!-- <span class="chatting-h-reload"></span>
					<span class="chatting-h-clear"></span> -->
				</div>
				<div class="chatting-h-custom">
					<span class="chatting-h-custom-online"
						:class="{'chatting-h-custom-outline' : chatUser.is_online == 0}" v-if="chatUser.is_transfer !== 1"></span>
					<span class="chatting-h-custom-name"><i v-if="chatUser.is_transfer === 1">转:{{chatUser.manager_name}}-</i>{{chatUser.custom_wx_name}}</span>
					<span class="chatting-h-custom-identity"
						v-if="chatUser.identity != null">-{{chatUser.identity}}</span>
					<img :src="chatUser.custom_wx_photo | connectHost" alt="">
				</div>
			</div>
		</div>
		<div class="chatting-content">
			<div class="chatting-content-wrap" id="chat-list" @scroll="chatScroll">
				<div class="chatting-content-more">
					<p v-if="hasMore == 0">没有更多消息了！</p>
					<p class="chatting-c-more-active" v-if="hasMore == 1">数据加载中，请稍后...</p>
				</div>
				<chatting :chatMsg="chatMsg" :chatUser="chatUser" :allImages="allImages" :showSelectMsg="showSelectMsg"
					:showTools="true" @chat-msg-click="chatMsgClick($event)" @select-msg-list="selectMsgList($event)"
					key="chat-chat-chatting-chatting">
				</chatting>
			</div>
			<div class="chatting-msg-num-box" v-if="chatting.no_read_num > 10 && showNum"
				@click="getListByNum(chatting.no_read_num)">
				<div class="chatting-msg-num">
					<span class="chatting-msg-num-icon"></span>
					<span>{{chatting.no_read_num}}条新信息</span>
				</div>
			</div>
		</div>
		<div class="chatting-tools">
			<chat-tools @chat-tool-call="chatToolCall($event)" @chat-tool-button-call="chatToolButtonCall($event)"
				:isFocus="isFocus" :chatType="chatUser.type" :chatId="chatUser.fans_id" :cwxid="chatUser.custom_wx_id" ref="childTools" key="ccc-st-ct"></chat-tools>
		</div>
		<div class="chatting-send">
			<div class="chatting-send-box">
				<chatting-input sendButtonId="chatting-send-submit" :chatToolsData="chatToolsData" modifyEnter
					@chat-input-focus="chatInputFocus($event)" @chat-input-msg="chatInputMsg($event)"
					key="chat-chat-chatting-ci" ref="childInput">
				</chatting-input>
			</div>
			<div class="chatting-send-option">
				<div class="cso-r">
					<div class="cso-ri">
						<label>自动翻译</label>
						<input type="checkbox" v-model="auoTranslate">
					</div>
					<div class="cso-ri">
						<span class="chatting-send-submit" @click="translate" style="width: 74px;">一键翻译</span>
					</div>
				</div>
				<span class="chatting-send-notice">按下Ctrl+Enter换行</span>
				<span class="chatting-send-submit" id="chatting-send-submit" @click="send">发送</span>
			</div>
		</div>
		<!-- 其他操作选项弹出页面-转账和红包等 -->
		<div class="chatting-shadow" v-if="showOpt">
			<chat-chat-opt :optData="optData" :cWxName="chatUser.custom_wx_name" @chat-opt-close="chatOptClose($event)">
			</chat-chat-opt>
		</div>
		<!-- 其他操作选项弹出页面-查看历史记录 -->
		<div class="chatting-shadow" v-if="showHistory">
			<chat-chat-history :fansId="chatting.friend_or_cluster_id" :chatType="parseInt(chatting.chat_type)"
				:chatUser="chatUser" @chat-history-close="showHistory = false">
			</chat-chat-history>
		</div>
		<!-- 其他操作选项弹出页面-聊天记录搜索页面 -->
		<div class="chatting-shadow" v-if="showRecordSearch">
			<chat-recod-search-comp :sKeyword="sKeyword" @record-search-close="showRecordSearch = false"
				@chat-click="chatClick($event)"></chat-recod-search-comp>
		</div>
		<!-- 其他操作选项弹出页面-查看订单记录 -->
		<div class="chatting-shadow" v-if="showOrder">
			<chat-chat-order :chatUser="chatUser" @chat-order-close="showOrder = false"> </chat-chat-order>
		</div>
		<!-- 其他操作选项弹出页面-转发好友消息 -->
		<div class="chatting-shadow" v-if="showShareMsg">
			<chat-chat-share-msg @chat-sharemsg-close="showShareMsg = false" @chat-sharemsg-cancel="chatSharemsgCancel"
				:selectMessage="selectMessage"></chat-chat-share-msg>
		</div>
		<!-- 其他操作选项弹出页面-展示游戏相关页面 -->
		<div class="chatting-shadow" v-if="showGame">
			<chat-chat-game :chatUser="chatUser" @chat-game-close="showGame = false"> </chat-chat-game>
		</div>
		<!-- 其他操作选项弹出页面-粉丝扩展信息相关 -->
		<div class="chatting-shadow" :class="{'chatting-shadow-left' : showDing}" v-if="customerExpansion">
			<chat-chat-customer-expansion :chatUser="chatUser" @chat-customer-expansion-close="expansionClose"
				@chat-expansion-ding="positonDing($event)"> </chat-chat-customer-expansion>
		</div>
		<!-- 其他操作选项弹出页面-粉丝对应转移窗口 -->
		<div class="chatting-shadow" v-if="showFansTransfer">
			<chat-fans-transfer :chatUser="chatUser" @chat-fans-transfer-close="fansTransferBack($event)">
			</chat-fans-transfer>
		</div>
	</div>
</template>

<script>
	import ChatTools from '../../components/ChatTools.vue'
	import Chatting from '../../components/Chatting.vue'
	import ChattingInput from '../../components/ChattingInput.vue'
	import {
		getFansWithCustomById
	} from '../../network/local/friend.js'
	import {
		getClusterDetailById
	} from '../../network/local/cluster.js'
	import {
		getChatRecordListByFansId,
		getChatRecordListByFansIdAndType,
		getChatRecordListByFansIdAndNum
	} from '../../network/local/chat-record.js'
	import {
		getClusterRecordListByClusterId,
		getClusterRecordListByFansIdAndType,
		getClusterRecordListByClusterIdAndNum
	} from '../../network/local/cluster-chat-record.js'
	import {
		sendMsg
	} from '../../socket/socketSender.js'
	import OssUploader from '../../functions/OssUploader.js'
	import ChatChatOpt from './ChatChatOpt.vue'
	import ChatChatHistory from './ChatChatHistory.vue'
	import ChatChatOrder from './ChatChatOrder.vue'
	import ChatRecodSearchComp from '../../components/record-search/ChatRecodSearchComp.vue'
	import ChatChatShareMsg from './ChatChatShareMsg.vue'
	import ChatChatGame from './ChatChatGame.vue'
	import ChatChatCustomerExpansion from './ChatChatCustomerExpansion.vue'
	import ChatFansTransfer from './ChatFansTransfer.vue'
	import {
		webGetFansWithCustomById
	} from '../../network/web/friend.js'
	import {webGetChatRecordListWithId} from '../../network/web/chat-record.js'
	import {delTransferData} from '../../network/local/fans-transfer.js'
	import {
		transferFans
	} from '../../socket/socketEventSender.js'
	import {webGetOrderUrl} from '../../network/web/other.js'
	import {webZhToEn,webEnToZh} from '../../network/web/fanyi.js'

	export default {
		name: 'ChatChatChatting',
		props: {
			chatting: {
				type: Object,
				default: function() {
					return {}
				}
			},
			sKeyword: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				hasMore: 1,
				firstId: 0,
				canRefresh: false,
				chatUser: {},
				chatMsg: [],
				message: [],
				chatToolsData: {},
				isFocus: 0,
				allImages: [],
				scrollTop: 0,
				showOpt: false,
				showHistory: false,
				showOrder: false,
				showRecordSearch: false,
				optData: {},
				showNum: true,
				showSelectMsg: false,
				showShareMsg: false,
				showGame: false,
				showFansTransfer: false,
				customerExpansion: false,
				selectMessage: [],
				showDing: false,
				aiteList: [],
				auoTranslate: false
			}
		},
		components: {
			ChatTools,
			Chatting,
			ChattingInput,
			ChatChatOpt,
			ChatChatHistory,
			ChatChatOrder,
			ChatRecodSearchComp,
			ChatChatShareMsg,
			ChatChatGame,
			ChatChatCustomerExpansion,
			ChatFansTransfer
		},
		methods: {
			// 初始化原始数据
			initData() {
				this.canRefresh = false
				this.chatMsg = []
				this.allImages = []
				this.firstId = 0
				this.hasMore = 1
				this.showOpt = false
				this.showHistory = false
				this.showOrder = false
				this.showRecordSearch = false
				this.optData = {}
				this.showNum = true
				this.showSelectMsg = false
				this.showShareMsg = false
				this.showGame = false
				this.customerExpansion = false
				this.selectMessage = []
				this.showFansTransfer = false
				this.aiteList = []
				let yswl_auto_fanyi = localStorage.getItem("yswl_auto_fanyi")
				if(yswl_auto_fanyi === undefined || yswl_auto_fanyi === null){
					yswl_auto_fanyi = false
				}
				if(yswl_auto_fanyi == false || yswl_auto_fanyi == 0){
					this.auoTranslate = false
				}else{
					this.auoTranslate = true
				}
			},

			// 菜单点击切换
			changeClick(value) {
				this.currentMenu = value
			},

			// 客服点击回调
			customClickCall(val) {
				val ? this.customDisplay = 'block' : this.customDisplay = 'none'
			},

			// 获取粉丝详细数据-联合客服信息
			showFansData() {
				// 正常的粉丝聊天
				if (this.chatting.is_transfer === undefined || this.chatting.is_transfer === 0) {
					getFansWithCustomById(this.chatting.friend_or_cluster_id, (data) => {
						this.chatUser = data
						this.chatUser.type = 1
						this.$store.commit('updateChatFans', this.chatUser)
					})
				} 
				// 转移的粉丝聊天信息获取
				else {
					webGetFansWithCustomById(this.chatting.friend_or_cluster_id,(data)=>{
						if(data.code == 1){
							this.chatUser = data.data
							this.chatUser.type = 1
							this.chatUser.is_transfer = 1
							this.$store.commit('updateChatFans', this.chatUser)
						}
					})
				}
			},

			// 获取群详细数据-联合客服信息
			showClusterData() {
				getClusterDetailById(this.chatting.friend_or_cluster_id, this.chatting.account_open_id, (data) => {
					if (data.fans_id === undefined) {
						return
					}
					// 组装成和粉丝信息一样的字段
					let fans = {
						fans_id: data.fans_id,
						fans_wx_id: data.fans_wx_id,
						fans_wx_name: data.fans_wx_name,
						fans_wx_photo: data.fans_wx_photo,
						custom_id: data.custom_id,
						con_remark: '',
						sex: 0,
						country: '',
						province: '',
						city: '',
						custom_wx_id: data.custom_wx_id,
						custom_wx_name: data.custom_wx_name,
						custom_wx_photo: data.custom_wx_photo,
						identity: data.identity,
						phone_id: data.phone_id,
						is_online: data.is_online,
						type: 2
					}
					this.chatUser = fans
					this.$store.commit('updateChatFans', this.chatUser)
				})
			},

			// 获取到数据后渲染页面
			handleMsgData(data, init) {
				let page = document.getElementById("chat-list")
				let len = data.length
				if (len > 0) {
					for (let i = 0; i < len; i++) {
						let chatType = 1
						if (data[i].wechat_cluster_id !== undefined) {
							chatType = 2
						}
						data[i].chatType = chatType
						this.chatMsg.unshift(data[i])
					}
					this.firstId = data[len - 1].id
					if (init !== true && init !== false) {
						this.canRefresh = true
					} else {
						if (len < 20) {
							this.canRefresh = false
							this.hasMore = 0
						} else {
							this.canRefresh = true
						}
					}
				} else {
					this.canRefresh = false
					this.hasMore = 0
				}
				// dom更新后在执行
				let o_scroll_h = 0
				if (page !== undefined) {
					o_scroll_h = page.scrollHeight
				}
				this.$nextTick(() => {
					if (init === true) {
						if (page !== undefined) {
							page.scrollTop = page.scrollHeight - page.clientHeight
						}
					} else if (init === false) {
						let top = page.scrollHeight - o_scroll_h
						if (top > 25) {
							page.scrollTop = top
						}
					} else {
						page.scrollTop = 35
					}
				})
			},

			// 聊天记录上滑刷新
			chatScroll(event) {
				let page = document.getElementById("chat-list")
				this.scrollTop = page.scrollTop
				if (page.scrollTop < 25 && this.canRefresh) {
					if (this.showNum && this.chatMsg.length > this.chatting.no_read_num) {
						this.showNum = false
					}
					this.canRefresh = false
					if (this.chatting.chat_type == 1) {
						this.showChatRecord(false)
					} else if (this.chatting.chat_type == 2) {
						this.showClusterRecord(false)
					}
				}
			},

			// 获取列表记录-普通聊天
			showChatRecord(init) {
				// 获取非转移的客户聊天记录
				if(this.chatting.is_transfer === undefined || this.chatting.is_transfer === 0){
					getChatRecordListByFansId(this.chatting.friend_or_cluster_id, this.firstId, data => {
						this.handleMsgData(data, init)
					})
				}
				// 获取转移客户的聊天记录
				else{
					let param = {
						id: this.chatting.friend_or_cluster_id,
						firstId: this.firstId,
						type: 1
					}
					webGetChatRecordListWithId(param,data=>{
						this.handleMsgData(data, init)
					})
				}
			},

			// 获取列表记录-群聊天
			showClusterRecord(init) {
				getClusterRecordListByClusterId(this.chatting.friend_or_cluster_id, this.chatting.account_open_id, this
					.firstId, data => {
						this.handleMsgData(data, init)
					})
			},

			// 获取当前聊天对象的所有图片消息-图片聊天
			getImageChatRecord(callBack) {
				getChatRecordListByFansIdAndType(this.chatting.friend_or_cluster_id, 'image', data => {
					let allImages = []
					for (let i = 0; i < data.length; i++) {
						allImages.push(data[i].content)
					}
					this.allImages = allImages
					callBack()
				})
			},

			// 获取当前聊天对象的所有图片消息-图片聊天
			getImageClusterChatRecord(callBack) {
				getClusterRecordListByFansIdAndType(this.chatting.friend_or_cluster_id, 'image', data => {
					let allImages = []
					for (let i = 0; i < data.length; i++) {
						allImages.push(data[i].content)
					}
					this.allImages = allImages
					callBack()
				})
			},

			// 组件初始化或粉丝切换时渲染数据
			drawFirstChat() {
				this.initData()
				// 普通聊天
				if (this.chatting.chat_type == 1) {
					this.showFansData()
					this.showChatRecord(true)
					this.getImageChatRecord(() => {
						// nothing to do
					})
				}
				// 群聊天
				else if (this.chatting.chat_type == 2) {
					this.showClusterData()
					this.showClusterRecord(true)
					this.getImageClusterChatRecord(() => {
						// nothing to do
					})
				}
			},

			// 根据指定数据获取聊天记录列表
			getListByNum(num) {
				this.initData()
				this.showNum = false
				// 普通聊天
				if (this.chatting.chat_type == 1) {
					getChatRecordListByFansIdAndNum(this.chatting.friend_or_cluster_id, num, data => {
						this.handleMsgData(data, 2)
					})
					this.getImageChatRecord(() => {
						// nothing to do
					})
				}
				// 群聊天
				else if (this.chatting.chat_type == 2) {
					getClusterRecordListByClusterIdAndNum(this.chatting.friend_or_cluster_id, this.chatting
						.account_open_id, num, data => {
							this.handleMsgData(data, 2)
						})
					this.getImageClusterChatRecord(() => {
						// nothing to do
					})
				}
			},

			// 发送消息
			send() {
				if (this.message.length === 0) {
					CHAT_LAYER.msg("发送消息不能为空！", {
						icon: 2
					})
					return
				}
				if(this.message.length > 1){
					for (let i = 0; i < this.message.length; i++) {
						// 判断是否为base64，如果是则上传后发送
						if (this.message[i].type == 'base64Image') {
							OssUploader.uploadBase64Chatting(this.message[i].content, data => {
								if (data && data.code == 1) {
									sendMsg(this.chatUser, data.path, 'image', this)
								}
							})
						} else {
							sendMsg(this.chatUser, this.message[i].content, this.message[i].type, this, '',this.aiteList)
						}
					}
					this.$refs.childInput.clearInput();
					this.$refs.childTools.currentTools = ''
					this.message = []
					this.chatToolsData = {}
					this.aiteList = []
				}else{
					// 如果是单条消息，需要判断发送的状态，是否置空输入内容
					let content = ''
					let type = ''
					for (let i = 0; i < this.message.length; i++) {
						content = this.message[i].content
						type = this.message[i].type
					}
					if(this.auoTranslate && type === 'text'){
						let loading = CHAT_LAYER.open({type: 3})
						webZhToEn({content:content},b_data=>{
							CHAT_LAYER.close(loading)
							if(b_data.code ==1){
								content = b_data.data.dst
								sendMsg(this.chatUser, content, type, this, '',this.aiteList,'',data=>{
									if(data){
										this.$refs.childInput.clearInput();
										this.$refs.childTools.currentTools = ''
										this.message = []
										this.chatToolsData = {}
										this.aiteList = []
									}
								})
							}else{
								CHAT_LAYER.msg(b_data.msg)
							}
						})
					}else{
						// 判断是否为base64，如果是则上传后发送
						if (type == 'base64Image') {
							OssUploader.uploadBase64Chatting(content, data => {
								if (data && data.code == 1) {
									sendMsg(this.chatUser, data.path, 'image', this)
									this.$refs.childInput.clearInput();
									this.$refs.childTools.currentTools = ''
									this.message = []
									this.chatToolsData = {}
									this.aiteList = []
								}
							})
						} else {
							sendMsg(this.chatUser, content, type, this, '',this.aiteList,'',data=>{
								if(data){
									this.$refs.childInput.clearInput();
									this.$refs.childTools.currentTools = ''
									this.message = []
									this.chatToolsData = {}
									this.aiteList = []
								}
							})
						}
					}
				}
			},

			// 监听工具栏
			chatToolCall(data) {
				// 如果是文件，直接发送
				if (data.type !== undefined) {
					if (data.type === 'file') {
						let files = data.data
						if (files !== undefined && files.length > 0) {
							for (let i = 0; i < files.length; i++) {
								let file = files[i]
								if (file.path === undefined || file.path === '') {
									continue
								}
								sendMsg(this.chatUser, JSON.stringify(file), 'file', this, 1)
							}
						}
					} else if (data.type === 'audio') {
						let files = data.data
						if (files !== undefined && files.length > 0) {
							let file = files[0]
							if (file.path !== undefined && file.path !== '' && file.duration !== undefined && file
								.duration > 0) {
								let voice = {
									voiceTime: file.duration,
									voiceUrl: file.path
								}
								sendMsg(this.chatUser, JSON.stringify(voice), 'voice', this)
							}
						}
					} else if (data.type === 'position') {
						let position = data.data
						if(position.qq_map === undefined){
							return
						}
						sendMsg(this.chatUser, JSON.stringify(position), 'position', this)
					}else if (data.type === 'clusterMember') {
						let member = data.data
						this.aiteList.push({
							call_all : member.call_all,
							f_wxid : member.friends_open_id,
							f_wname : member.friends_wx_name,
							w_id : member.wechat_cluster_id
						})
						this.chatToolsData = data
					}else {
						this.chatToolsData = data
					}
				}
				// 其他的类型，赋值到输入框
				else {
					this.chatToolsData = data
				}
			},

			// 监听输入框聚焦
			chatInputFocus(val) {
				this.isFocus = parseInt(val)
				this.showSelectMsg = false
				this.selectMessage = []
			},

			// 监听输入框消息返回
			chatInputMsg(val) {
				this.message = val
			},

			// 监听消息点击
			chatMsgClick(msg) {
				console.log(msg)
			},

			// 操作页面关闭回调
			chatOptClose() {
				this.showOpt = false
				this.optData = {}
			},

			// 客户扩展资料关闭
			expansionClose() {
				this.customerExpansion = false
				this.showDing = false
			},

			// 工具栏按钮点击回调，只是返回点击回调按钮的值
			chatToolButtonCall(val) {
				if (val === 'history') {
					this.showHistory = !this.showHistory
				} else if (val === 'order') {
					this.showOrder = !this.showOrder
				} else if (val === 'shareMsg') {
					this.showSelectMsg = !this.showSelectMsg
					if (!this.showSelectMsg) {
						this.selectMessage = []
					}
				} else if (val === 'shareMsgCancel') {
					this.showSelectMsg = false
					this.selectMessage = []
				} else if (val === 'shareMsgOneByOne' || val === 'shareMsgMerge') {
					this.showShareMsg = true
				} else if (val === 'game') {
					this.showGame = !this.showGame
				} else if (val === 'customer_expansion') {
					this.customerExpansion = !this.customerExpansion
					this.showDing = false
				} else if (val === 'fans_transfer') {
					if(this.chatting.chat_type !== undefined){
						if(this.chatting.chat_type == 1){
							this.showFansTransfer = !this.showFansTransfer
						}else{
							CHAT_LAYER.msg('不支持群对话转移！')
						}
					}
				}if (val === 'order2') {
					webGetOrderUrl(this.chatUser.fans_id,data=>{
						if(data.code == 1){
							window.open(data.data.url,'_blank')
						}
					})
					
					return
				}
				// 如果是其他消息类型，关闭消息选择
				let showSelectMsgOrders = ["shareMsg", "shareMsgCancel", "shareMsgOneByOne", "shareMsgMerge"]
				if (showSelectMsgOrders.indexOf(val) === -1) {
					this.showSelectMsg = false
					this.selectMessage = []
				}
			},

			// 搜索页面点击进入聊天后的回调
			chatClick(data) {
				this.$emit('reshow-chatting', data)
			},

			// 消息列表页面，消息选择后回调
			selectMsgList(data) {
				this.selectMessage = data
			},

			// 转发消息取消回调-粉丝选择页面的
			chatSharemsgCancel() {
				this.selectMessage = []
				this.showSelectMsg = false
				this.showShareMsg = false
				this.$refs.childTools.currentTools = ''
			},

			// 扩展页面的显示位置
			positonDing(data) {
				if (data === 'left') {
					this.showDing = true
				} else {
					this.showDing = false
				}
			},
			
			// 粉丝转移回调
			fansTransferBack(data){
				this.showFansTransfer = false
				if(data === undefined){
					return
				}
				// 删除记录
				if(data.del !== undefined && data.del == 1){
					delTransferData(data.fans_id,(data2)=>{
						// 删除页面数据
						this.$emit('transfer-fans',data)
					})
				}
				// 推送转移事件消息
				transferFans(data.admin_id,data.custom_id,data.fans_id,data.to_org)
			},
			
			// 一键翻译当前聊天记录
			translate(){
				this.chatMsg.forEach((item,index)=>{
					if(item.type === 'text' && item.content.indexOf('译文:') === -1){
						let temp = JSON.parse(JSON.stringify(item))
						item.id = Date.now()+item.id
						item.content = '翻译中，请稍后。。。'
						this.$set(this.chatMsg, index, item)
						webEnToZh({content:temp.content,type:'all'},b_data=>{
							if(b_data.code ==1){
								temp.content = '译文:'+b_data.data.dst
							}
							this.$set(this.chatMsg, index, temp)
						})
					}
				})
			},
			
			// 渲染新消息
			drawNewMsg(nVal){
				// 群消息需要单独判断是否发送到本人
				if (nVal.chatType == 2) {
					if (nVal.toId !== this.chatUser.custom_wx_id) {
						return
					}
				}
				if (nVal.fans_id == this.chatUser.fans_id) {
					// 判断是新增还是更新
					if (nVal.is_update > 0) {
						let index = -1
						for (var i = 0; i < this.chatMsg.length; i++) {
							if (this.chatMsg[i].id == nVal.id) {
								index = i
								break
							}
						}
						if (index !== -1) {
							if (nVal.is_update == 1) {
								this.chatMsg[i].is_send = 1
							} else if (nVal.is_update == 2) {
								this.chatMsg[i].is_send = 0
							}
						}
					} else {
						this.chatMsg.push(nVal)
						let page = document.getElementById("chat-list")
						// 如果是图片类型，则添加到预览图中
						if (nVal.type == 'image') {
							this.allImages.push(nVal.content)
						}
				
						// dom更新后在执行
						this.$nextTick(() => {
							if (page !== null) {
								page.scrollTop = page.scrollHeight + page.clientHeight
							}
						})
					}
				}
			}
		},

		computed: {
			// 新消息
			newMsg() {
				return this.$store.state.currentChatMsg
			},

			// 监听vuex中的其他事件
			otherData() {
				return this.$store.state.otherEvent
			},
		},

		watch: {
			// 监听当前聊天对象的变化
			chatting(val) {
				this.drawFirstChat()
			},

			// 监听新的消息
			newMsg(nVal, oVal) {
				nVal = JSON.parse(JSON.stringify(nVal))
				if(this.auoTranslate && nVal.type === 'text' && nVal.is_me != 1){
					webEnToZh({content:nVal.content},b_data=>{
						if(b_data.code ==1){
							nVal.content = '译文:'+b_data.data.dst
						}
						this.drawNewMsg(nVal)
					})
				}else{
					this.drawNewMsg(nVal)
				}
			},

			// 监听vuex中的其他事件
			otherData(nVal) {
				if (nVal.type === undefined) {
					return
				}
				// 红打开和转账页面的回调处理
				if (nVal.type === 'RedPackageOpenResult' || nVal.type === 'TransferAccountsOpen' || nVal.type ===
					'redPackage' || nVal.type === 'transferAccounts') {
					let optData = JSON.parse(JSON.stringify(nVal))
					this.optData = optData
					this.showOpt = true
					// 更新当前聊天页面
					if (optData.type === 'redPackage' || optData.type === 'transferAccounts') {
						if (optData.id !== undefined && optData.msgType !== undefined) {
							let index = -1
							for (var i = 0; i < this.chatMsg.length; i++) {
								if (this.chatMsg[i].id == optData.id) {
									index = i
									break
								}
							}
							if (index !== -1) {
								let replace_msg = JSON.parse(JSON.stringify(this.chatMsg[index]))
								replace_msg.type = optData.msgType
								this.$set(this.chatMsg,index,replace_msg)
							}
						}
					}
				}
				// 消息撤回和删除事件回调处理
				else if (nVal.type === 'messageWithdraw_d' || nVal.type === 'messageDelete') {
					let content = '您撤回了一条消息！'
					if (nVal.content !== undefined) {
						content = nVal.content
					}
					for (var i = 0; i < this.chatMsg.length; i++) {
						if (this.chatMsg[i].id == nVal.recodeId) {
							let msg = JSON.parse(JSON.stringify(this.chatMsg[i]))
							msg.type = 'system'
							msg.content = content
							this.chatMsg.splice(i, 1)
							this.chatMsg.push(msg)
							break
						}
					}
				}
			},

			sKeyword(nVal) {
				if (nVal !== '') {
					this.showRecordSearch = true
				}
			},
			
			// 保存到缓存中
			auoTranslate(nVal){
				let yswl_auto_fanyi = 0
				if(nVal){
					yswl_auto_fanyi = 1
				}
				localStorage.setItem("yswl_auto_fanyi",yswl_auto_fanyi)
			}
		},
		created() {
			this.drawFirstChat()
		},

		// 只有组件被缓存时，才会调用这2个方法
		activated() {
			let page = document.getElementById("chat-list")
			page.scrollTop = this.scrollTop
		},
	}
</script>

<style>
	.chatting-container {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
		border-left: 1px solid #cccccc;
		border-right: 1px solid #cccccc;
		box-sizing: border-box;
	}

	.chatting-container .chatting-header {
		width: 100%;
		height: 49px;
		line-height: 49px;
		border-bottom: 1px solid #cccccc;
	}

	.chatting-header .chatting-header-wrap {
		width: 100%;
		height: 49px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		padding: 0 20px;
	}

	.chatting-header-wrap .chatting-h-basic,
	.chatting-header-wrap .chatting-h-custom {
		max-width: 50%;
		height: 49px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		align-content: center;
		flex-wrap: nowrap;
		font-size: 14px;
	}

	.chatting-h-basic>*,
	.chatting-h-custom>* {
		display: block;
		margin: 0 5px
	}

	.chatting-h-basic img,
	.chatting-h-custom img {
		width: 36px;
		height: 36px;
		border-radius: 4px;
	}

	.chatting-h-basic .chatting-h-info {
		padding: 5px 0;
		height: 38px;
		line-height: 19px;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	.chatting-h-info>p {
		width: 100%;
		height: 19px;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-all;
		white-space: nowrap;
	}

	.chatting-h-info .chatting-h-other {
		font-weight: normal;
		font-size: 12px;
		color: #999999;
	}

	.chatting-h-other span {
		display: inline-block;
		margin-right: 5px;
		vertical-align: middle;
	}

	.chatting-h-other .chatting-h-male {
		width: 16px;
		height: 16px;
		background-image: url(../../assets/img/male-icon.png);
		background-size: cover;
		background-position: center;
	}

	.chatting-h-other .chatting-h-female {
		width: 16px;
		height: 16px;
		background-image: url(../../assets/img/female-icon.png);
		background-size: cover;
		background-position: center;
	}

	.chatting-h-custom .chatting-h-custom-name {
		margin-right: 0;
		overflow: hidden;
		height: 49px;
	}

	.chatting-h-custom .chatting-h-custom-identity {
		margin-left: 0;
		font-weight: bold;
		color: #d23131;
	}

	.chatting-h-custom .chatting-h-custom-online {
		width: 10px;
		height: 10px;
		background-color: #42B983;
		margin-right: 0;
		border-radius: 5px;
	}

	.chatting-h-custom .chatting-h-custom-outline {
		background-color: #d23131 !important;
	}

	.chatting-container .chatting-content {
		position: absolute;
		top: 50px;
		left: 0;
		right: 0;
		bottom: 230px;
		overflow: hidden;
		border-bottom: 1px solid #CCCCCC;
	}

	.chatting-content .chatting-content-wrap {
		position: relative;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.chatting-content-wrap::-webkit-scrollbar {
		width: 6px;
		height: auto;
	}

	.chatting-content-wrap::-webkit-scrollbar-track {
		border-radius: 3px;
		background: #e3e3e3;
	}

	.chatting-content-wrap::-webkit-scrollbar-thumb {
		border-radius: 3px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #cbcbcb;
		cursor: pointer;
	}

	.chatting-content-wrap .chatting-content-more {
		height: 24px;
		line-height: 24px;
		overflow: hidden;
		text-align: center;
		color: #969696;
		font-size: 12px;
	}

	.chatting-content-more .chatting-c-more-active {
		color: #299615;
	}

	.chatting-container .chatting-tools {
		width: 100%;
		height: 50px;
		position: absolute;
		left: 0;
		bottom: 180px;
		right: 0;
	}

	.chatting-container .chatting-send {
		width: 100%;
		height: 180px;
		position: absolute;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.chatting-send .chatting-send-box {
		width: 100%;
		height: 130px;
	}

	.chatting-send .chatting-send-option {
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.chatting-send-option span {
		display: block;
	}

	.chatting-send-option .chatting-send-notice {
		font-size: 13px;
		color: #999999;
	}

	.chatting-send-option .chatting-send-submit {
		width: 50px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		margin-left: 10px;
		cursor: pointer;
		background-color: #42B983;
		color: #FFFFFF;
	}

	.chatting-shadow {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #0000008a;
		z-index: 10;
	}

	.chatting-shadow-left {
		position: fixed !important;
		top: 0;
		left: 0;
		bottom: 0;
		width: 480px;
		background-color: #0000008a;
		z-index: 10;
	}

	.chatting-content .chatting-msg-num-box {
		position: absolute;
		top: 40%;
		right: 6px;
		color: #27de11;
		overflow: hidden;
		user-select: none;
	}

	.chatting-msg-num-box .chatting-msg-num {
		background-color: #FFFFFF;
		padding: 5px 10px;
		border: 1px solid #27de11;
		height: 20px;
		line-height: 20px;
		border-radius: 16px;
		transform: translateX(12px);
		cursor: pointer;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.chatting-msg-num span {
		display: inline-block;
		margin-right: 5px;
	}

	.chatting-msg-num .chatting-msg-num-icon {
		height: 20px;
		width: 20px;
		background-image: url(../../assets/img/top_double_arrow.png);
		background-position: center;
		background-size: 14px auto;
		background-repeat: no-repeat;
		margin-right: 0;
	}
	.cso-r{
		flex: 1;
		display: flex;
		align-items: center;
	}
	.cso-ri{
		display: flex;
		align-items: center;
	}
	.cso-ri label{
		margin-right: 5px;
	}
</style>
